import {tokenURL} from './baseURL';
function decodeBase64(encodedData) {
    return decodeURIComponent(escape(atob(encodedData)));
}
export const fetchAccessToken = async (SRA1, SRA2) => {
    //console.log(SRA1, decodeBase64(SRA2));
    try {
        const body = new URLSearchParams({
            UserName: SRA1, 
            Password: decodeBase64(SRA2), 
            grant_type: "password"
        });

        const response = await fetch(`${tokenURL()}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: body.toString()
        });

        if (!response.ok) {
            throw new Error("Failed to fetch token");
        }

        const data = await response.json();

        return data.access_token;

    } catch (error) {
        console.error("Token API Error:", error);
        throw error;
    }
};